import { Vazio } from '../ds/Vazio.js';

/* Sem `h1`: quem o carrega é o cabeçalho preso da `Casca`, que já mostra o
 * nome da aba. Dois títulos com o mesmo texto, um debaixo do outro, era o que
 * a tela fazia antes — e em AX5 custava a primeira tela inteira. O `titulo`
 * continua chegando por prop porque é ele que nomeia a região para o
 * VoiceOver, sem pintar nada.
 *
 * `Vazio` sem `nivel`: o cabeçalho da aba já é o cabeçalho desta tela, e um
 * `h2` aqui repetiria a mesma palavra um degrau abaixo. */
export function EmConstrucao({ titulo }: { titulo: string }) {
  return (
    <section aria-label={titulo}>
      <Vazio
        titulo="Esta tela chega numa etapa seguinte."
        descricao="O que você registrar hoje continua guardado e aparece aqui quando ela existir."
      />
    </section>
  );
}
